import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    tours: [],
    status:'idle'
};

export const fetchTourProgresses = createAsyncThunk('credit-audit/fetchTourProgresses', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getTourProgresses',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});
export const updateTourProgress = createAsyncThunk('credit-audit/updateTourProgress', async ({tour_name, completed}) => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append("Token",accessToken);
  formData.append("tour_name",tour_name);
  formData.append("completed",completed);
  let response = await axios.post('form/createOrUpdateTourProgress',formData);
  if (response.status === 200) {
      if(response.data.error!=2){
          return response.data;
      }else{
          removeLocalStorage();
          window.location.href = "/";
      }
  }else{
      throw new Error(response.statusText)
  }
});
export const deleteTourProgress = createAsyncThunk('credit-audit/deleteTourProgress', async ({tour_name}) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("tour_name",tour_name);
    let response = await axios.post('form/deleteTourProgress',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
  });

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const TourProgressSlice = createSlice({
    name:'tour-progress',
    initialState,
    reducers:{
        blankTours:(state)=>{
            state.status = "idle";
            state.tours = [];
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchTourProgresses.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchTourProgresses.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.tours = action.payload.data;
        })
        builder.addCase(fetchTourProgresses.rejected,(state,action)=>{
            state.status = 'failed';
            state.tours = [];
        })
        builder.addCase(updateTourProgress.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(updateTourProgress.fulfilled,(state,action)=>{
          state.status = 'idle';
          state.tours = [];
        })
        builder.addCase(deleteTourProgress.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(deleteTourProgress.fulfilled,(state,action)=>{
            state.status = 'idle';
            state.tours = [];
        })
    }
});

export const {blankTours} = TourProgressSlice.actions;

export default TourProgressSlice.reducer;

